export const PASSWORD_MIN_LENGTH = 9

export enum PasswordStrength {
  EMPTY_PASSWORD = 'EMPTY_PASSWORD',
  SHORT_PASSWORD = 'SHORT_PASSWORD',
  WEAK_PASSWORD = 'WEAK_PASSWORD',
  DECENT_PASSWORD = 'DECENT_PASSWORD',
  STRONG_PASSWORD = 'STRONG_PASSWORD',
  STRONGEST_PASSWORD = 'STRONGEST_PASSWORD',
}
